<template>
  <div class="global-container">
    <div class="space-3"></div>
    <BaseBtn
      ref="backBtn"
      variant="primary"
      class="hidden-back-btn ml-lg"
      :class="{ visible: showHiddenBackBtn }"
      to="/projekte"
    >
      <svg
        width="50px"
        height="50px"
        viewBox="0  0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 12H20M4 12L8 8M4 12L8 16"
          stroke="#b7b7b7"
          stroke-width="1.35"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </BaseBtn>

    <div class="btns">
      <div class="back__btn__wrapper">
        <router-link to="/projekte"
          ><svg
            width="50px"
            height="50px"
            viewBox="0  0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 12H20M4 12L8 8M4 12L8 16"
              stroke="#7d817e"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          Projekte</router-link
        >
      </div>
      <div class="next__btn__wrapper">
        <router-link :to="nextProjectUrl">
          Nächstes Projekt
          <svg
            width="50px"
            height="50px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 12H4M20 12L16 8M20 12L16 16"
              stroke="#7d817e"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </router-link>
      </div>
    </div>
    <div class="mobile-vis"></div>
    <div v-if="project" class="detail__wrapper">
      <p class="category-p mb-md mt-xxl">{{ project.category }}</p>
      <div class="detail__info mt-md">
        <h2>{{ project.title }}</h2>
        <div class="detail__txt">
          <p>{{ project.detailsText }}</p>
        </div>
      </div>
      <div class="space-3"></div>
      <div class="img__gallery" v-if="projectImages.length">
        <div class="img__container">
          <img
            v-for="(image, index) in projectImages"
            :key="index"
            :src="image"
            :alt="`Bild ${index + 1} von ${project.title}`"
          />
        </div>
      </div>
    </div>
    <div class="space-3"></div>
    <div class="next__btn__wrapper">
      <router-link :to="nextProjectUrl">
        Nächstes Projekt
        <svg
          width="50px"
          height="50px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 12H4M20 12L16 8M20 12L16 16"
            stroke="#7d817e"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { projects } from "@/data/data";
import { images } from "@/data/data";
import BaseBtn from "./BaseBtn.vue";

const route = useRoute();

const showHiddenBackBtn = ref(false);
const backBtn = ref(null);

const props = defineProps({
  URLtitle: String,
  id: [String, Number],
});
const project = computed(() => {
  return projects.find((p) => p.id == route.params.id);
});

const nextProjectIndex = computed(() => {
  const currentIndex = projects.findIndex((p) => p.id == route.params.id);
  return currentIndex !== -1 && currentIndex < projects.length - 1
    ? currentIndex + 1
    : 0;
});

const nextProjectUrl = computed(() => {
  const nextProject = projects[nextProjectIndex.value];
  return `/projekte/${nextProject.URLtitle}/${nextProject.id}`;
});

const projectImages = computed(() => {
  if (!project.value) return [];
  return images[project.value.category]?.[project.value.projectName] || [];
});

const handleScroll = () => {
  showHiddenBackBtn.value = window.scrollY > 100;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped lang="scss">
.hidden-back-btn {
  display: flex;
  align-items: center;
  gap: map-get($spaces, "xs");
  padding: map-get($spaces, "xxs") map-get($spaces, "sm");
  position: fixed;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  max-width: fit-content;
  background-color: $bg--col--07;
  &:active {
    background-color: $text--muted;
  }
  &.visible {
    opacity: 1;
    visibility: visible;
  }
  svg {
    width: 2em;
  }
}
.next__btn__wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  svg {
    height: auto;
    width: 1.7em;
    transform: translateX(3px);
  }
  a {
    display: flex;
    align-items: center;
    color: $text--muted;
    transition: all 0.2 ease;
    font-size: 1.615rem;
    @media (max-width: 768px) {
      font-size: 1.215rem;
    }
    &:hover {
      text-decoration: 2.25px underline $text--muted;
      text-underline-offset: 3px;
    }
  }
}
.btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .back__btn__wrapper {
    width: fit-content;
    svg {
      height: auto;
      width: 1.7em;
      transform: translateX(-3px);
    }
    a {
      display: flex;
      align-items: center;
      color: $text--muted;
      font-size: 1.615rem;
      @media (max-width: 768px) {
        font-size: 1.215rem;
      }
      transition: all 0.2 ease;
      &:hover {
        text-decoration: 2.25px underline $text--muted;
        text-underline-offset: 3px;
      }
    }
  }
  .next__btn__wrapper {
    width: fit-content;

    svg {
      height: auto;
      width: 1.7em;
      transform: translateX(3px);
    }
    a {
      display: flex;
      align-items: center;
      color: $text--muted;
      transition: all 0.2 ease;
      font-size: 1.615rem;
      @media (max-width: 768px) {
        font-size: 1.215rem;
      }
      &:hover {
        text-decoration: 2.25px underline $text--muted;
        text-underline-offset: 3px;
      }
    }
  }
}
.detail__wrapper {
  .category-p {
    display: inline-block;
    padding: 0.5em 1.6em;
    text-align: center;
    border-radius: 999px;
    width: fit-content;
    border: 1px solid $text--muted;
    p {
      color: $text--muted;
    }
  }
  width: 100%;
  .detail__info {
    display: flex;
    flex-direction: column;
    gap: map-get($spaces, "sm");
    h2 {
      font-weight: 520;
    }
    .detail__txt {
      display: flex;
      flex-direction: column;
      gap: map-get($spaces, "xs");
    }
  }
  .img__gallery {
    width: 100%;
    .img__container {
      column-count: 1;
      border-radius: map-get($spaces, "xxs");
      @media (min-width: 768px) {
        column-count: 2;
        column-gap: map-get($spaces, "md");
      }
      @media (min-width: 1440px) {
        column-count: 3;
      }
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: map-get($spaces, "xxs");
        object-fit: contain;
        margin-bottom: map-get($spaces, "sm");
        @media (min-width: 768px) {
          margin-bottom: map-get($spaces, "md");
        }
      }
    }
  }
}
</style>
